import Validatable from "../../../common/mixins/validatable";
import CertificateBuilderModel from "../../../common/models/tracked/certificateBuilderModel";
import IRepo from "../../../common/interfaces/repo";
import Repo from "../../../common/state/modules/repo";
import Guid from "~/helpers/guid";
import {ObjectModelBuiltinPropertyType} from "~/enums/objectModelBuiltinPropertyType";
import {Hash} from "~/interfaces/hashInterfaces";
import {RelationType} from "~/models/relationType";
import CertificateMappedModelRelation from "./certificateMappedModelRelation";
import {ObjectHelper} from "~/helpers/objectHelper";
import CertificateMappedModelRelationFactory from "./certiicateMappedModelRelationFactory";
import ICertificateMappedRelationInfo from "./mappedRelationInfo";
import CertificateMappedFormElementContainer from "./certificateMappedFormElementContainer";
import CertificateMappedFormElementContainerFactory from "./certificateMappedFormElementContainerFactory";
import Form from "../../form_builder/models/form";

export default class CertificateMapping extends Validatable(CertificateBuilderModel) {

  static repo: IRepo<CertificateMapping> = new Repo<CertificateMapping>('certificateMappings', CertificateMapping);

  client_id: string;
  // client ID of the form/license/object model
  form_id: string;
  form_fields: Hash<string> = {};
  mapped_builtin_properties: Hash<ObjectModelBuiltinPropertyType>;
  mapped_model_relations: Hash<CertificateMappedModelRelation> = {};
  mapped_form_element_containers: Hash<CertificateMappedFormElementContainer> = {};
  get rootName(): string {
    return 'certificate_mappings';
  }

  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    return {
      'mapped_model_relations': { type: CertificateMappedModelRelation, relationType: RelationType.dictionary },
      'mapped_form_element_containers': { type: CertificateMappedFormElementContainer, relationType: RelationType.dictionary },

    };
  }

  createEmbeddedObject = {
    mapped_model_relations: (parent, json) => {
      return new CertificateMappedModelRelation(parent, json);
    },
    mapped_form_element_containers: (parent, json) => {
      return new CertificateMappedFormElementContainer(parent, json);
    },
  }

  definePropertiesFrom(certificate, json) {
    this.defineProperty('client_id', json["client_id"] || Guid.create());
    this.defineProperty("form_id", json['form_id'] || this.form_id);
    this.defineProperty("form_fields", json['form_fields'] || this.form_fields);
    this.defineProperty("mapped_builtin_properties", json['mapped_builtin_properties'] || this.mapped_builtin_properties);
  }

  setRelation(inputClientId: string, relationPath: ICertificateMappedRelationInfo[]) {
    let relation = this.mappedModelRelationForInput(inputClientId);
    if (!relation) {
      relation = CertificateMappedModelRelationFactory.create(this, {input_client_id: inputClientId});
    }
    relation.relation_path = relationPath;
  }

  setFormElemmentContainer(inputClientId: string, formElementClientId: string ) {
    let formElementContainer = this.mappedFormElementContainerForInput(inputClientId);
    if (!formElementContainer) {
      formElementContainer = CertificateMappedFormElementContainerFactory.create(this, {input_client_id: inputClientId, form_element_client_id: formElementClientId});
    }
  }
  get mappedModelRelationsArray(): CertificateMappedModelRelation[] {
    return ObjectHelper.toArray(this.mapped_model_relations);
  }

  get mappedFormElementContainersArray(): CertificateMappedFormElementContainer[] {
    return ObjectHelper.toArray(this.mapped_form_element_containers);
  }


  mappedModelRelationForInput(inputClientId: string): CertificateMappedModelRelation | null {
    return this.mappedModelRelationsArray.find(x => x.input_client_id === inputClientId);
  }

  mappedFormElementContainerForInput(inputClientId: string): CertificateMappedFormElementContainer {
    return this.mappedFormElementContainersArray.find(x => x.input_client_id === inputClientId);
  }

  get mappedForm() :  Form {
   return Form.repo.find(this.form_id)
  }

  resetMapping(): void {
    this.form_id = null;
    this.form_fields = {};
    this.mapped_builtin_properties = {};
    this.mapped_model_relations = {};
  }
}